// reducers.js
import {FETCH_BANNER, FETCH_DRAWER_MENU, FETCH_LATEST_VERSION, SET_BANNER, SET_DRAWER_MENU} from '../actions';
import {SET_LATEST_VERSION} from "../actions";
// import {SET_LATEST_VERSION} from "./actionTypes";

const initialState = {
    bannerData: null,
    isLoading: false,
    error: null,
};

const bannerReducer = (state = initialState, action) => {


    switch (action.type) {

        case FETCH_BANNER:
            return {
                ...state,
            };

        case SET_BANNER:
            return {
                ...state,
                bannerData: action.payload,
                isLoading: false,
            };

        default:
            return state;
    }
};

export default bannerReducer;
